import React from 'react';

const WhyChoose = () => {
  return (
    <section className="why-choose">
      <div className="container">
        <h2>Why Choose BankSystem?</h2>
        <p style={{
          color: 'var(--text-secondary)',
          fontSize: '1.125rem',
          maxWidth: '800px',
          margin: '0 auto 3rem',
          textAlign: 'center',
          lineHeight: '1.6'
        }}>
          The world's first independent Web3 banking ecosystem - built on Ethereum, powered by ENS, and secured by enterprise-grade technology.
        </p>
        <div className="cards">
          <div className="card">
            <i className="fas fa-wallet"></i>
            <h3>BankSystem Wallet</h3>
            <p className="eth-label">Enterprise-Grade Security</p>
            <p>Military-grade PBKDF2/AES-256 encryption with local wallet creation and multi-wallet management.</p>
          </div>
          <div className="card">
            <i className="fas fa-id-card"></i>
            <h3>ENS Identity</h3>
            <p className="eth-label">Your .xbsys.eth Domain</p>
            <p>Custom ENS contract for seamless identity management. Universal access to all BankSystem services.</p>
          </div>
          <div className="card">
            <i className="fas fa-robot"></i>
            <h3>Grok xAI Powered</h3>
            <p className="eth-label">Intelligent Banking</p>
            <p>Advanced AI provides trading insights, portfolio advice, and 24/7 support across all services.</p>
          </div>
          <div className="card">
            <i className="fas fa-cubes"></i>
            <h3>Complete Ecosystem</h3>
            <p className="eth-label">All-in-One Platform</p>
            <p>Payments, Cash, Forex, Brokerage, Markets - everything you need in one independent ecosystem.</p>
          </div>
          <div className="card">
            <i className="fas fa-coins"></i>
            <h3>Transparent Equity</h3>
            <p className="eth-label">$DBANK Shares</p>
            <p>Own a piece of the ecosystem with tokenized shares and real dividend distribution.</p>
          </div>
          <div className="card">
            <i className="fas fa-users"></i>
            <h3>Community Voice</h3>
            <p className="eth-label">MoneyTalks Forums</p>
            <p>Join our vibrant financial community powered by Drupal integration for open discussion.</p>
          </div>
          <div className="card">
            <i className="fas fa-money-bill-wave"></i>
            <h3>Lowest Fees</h3>
            <p className="eth-label">Always Competitive</p>
            <p>Enjoy the industry's lowest fees, undercutting traditional financial services worldwide.</p>
          </div>
          <div className="card">
            <i className="fas fa-shield-alt"></i>
            <h3>Independent Infrastructure</h3>
            <p className="eth-label">No Middlemen</p>
            <p>BankSystem-owned ENS contracts and custom infrastructure ensure complete independence and security.</p>
          </div>
        </div>

        {/* Ecosystem Highlight */}
        <div style={{
          marginTop: '3rem',
          padding: '2rem',
          backgroundColor: 'var(--card-bg)',
          borderRadius: '10px',
          boxShadow: '0 4px 8px var(--gold-shadow)',
          textAlign: 'center',
          border: '2px solid var(--gold)'
        }}>
          <h3 style={{ color: 'var(--gold)', marginBottom: '1rem' }}>
            🏦 Independent Web3 Banking Ecosystem
          </h3>
          <p style={{ color: 'var(--text-light)', marginBottom: '1.5rem', lineHeight: '1.6' }}>
            BankSystem operates as a completely independent financial ecosystem with custom ENS Domains & Smart Contracts,
            enterprise-grade wallet security, and owned Web3 infrastructure - no dependencies on third-party providers.
          </p>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
            gap: '1rem',
            marginTop: '1.5rem'
          }}>
            <div style={{ textAlign: 'center' }}>
              <div style={{
                background: 'rgba(0,255,136,0.1)',
                padding: '0.5rem',
                borderRadius: '8px',
                marginBottom: '0.5rem',
                display: 'inline-block'
              }}>
                <i className="fas fa-code" style={{ color: '#00ff88', fontSize: '1.5rem' }}></i>
              </div>
              <p style={{ color: 'var(--text-light)', fontSize: '0.875rem', margin: '0' }}>Custom ENS & Smart Contracts</p>
            </div>
            <div style={{ textAlign: 'center' }}>
              <div style={{
                background: 'var(--gold-shadow)',
                padding: '0.5rem',
                borderRadius: '8px',
                marginBottom: '0.5rem',
                display: 'inline-block'
              }}>
                <i className="fas fa-server" style={{ color: 'var(--gold)', fontSize: '1.5rem' }}></i>
              </div>
              <p style={{ color: 'var(--text-light)', fontSize: '0.875rem', margin: '0' }}>Owned Infrastructure</p>
            </div>
            <div style={{ textAlign: 'center' }}>
              <div style={{
                background: 'rgba(0,100,255,0.1)',
                padding: '0.5rem',
                borderRadius: '8px',
                marginBottom: '0.5rem',
                display: 'inline-block'
              }}>
                <i className="fas fa-shield-alt" style={{ color: '#0064ff', fontSize: '1.5rem' }}></i>
              </div>
              <p style={{ color: 'var(--text-light)', fontSize: '0.875rem', margin: '0' }}>Bank-Grade Security</p>
            </div>
            <div style={{ textAlign: 'center' }}>
              <div style={{
                background: 'rgba(255,140,0,0.1)',
                padding: '0.5rem',
                borderRadius: '8px',
                marginBottom: '0.5rem',
                display: 'inline-block'
              }}>
                <i className="fas fa-network-wired" style={{ color: '#ff8c00', fontSize: '1.5rem' }}></i>
              </div>
              <p style={{ color: 'var(--text-light)', fontSize: '0.875rem', margin: '0' }}>Independent Network</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChoose;
